import { combineReducers } from '@reduxjs/toolkit'

import { catalogReducer } from './features/catalog/model/catalogSlice'
import { deliveryReducer } from './features/delivery/model/deliverySlice'
import { pricesReducer } from './features/prices/model/pricesSlice'
import { incidentsReducer } from './features/incidents/model/incidentsSlice'
import { receiptsReducer } from './features/receipts/model/receiptsSlice'
import { shiftsReducer } from './features/shifts/model/shiftsSlice'
import { refundCommandsReducer } from './features/refunds/model/refundCommandsSlice'
import { refundsReducer } from './features/refunds/model/refundsSlice'
import { cartReducer } from './features/sale/model/cartSlice'
import { fastReceiptsReducer } from './features/sale/model/fastReceiptsSlice'
import { paymentAttemptsReducer } from './features/sale/model/paymentAttemptsSlice'
import { saleCommandsReducer } from './features/sale/model/saleCommandsSlice'
import { saleReducer } from './features/sale/model/saleSlice'
import { cashierAccessReducer } from './features/rmk/model/cashierAccessSlice'
import { openingReducer } from './features/rmk/model/openingSlice'
import { operationsReducer } from './features/rmk/model/operationsSlice'
import { shiftReadsReducer } from './features/rmk/model/shiftReadsSlice'
import { startReducer } from './features/rmk/model/startSlice'
import { feedbackReducer } from './shared/model/feedbackSlice'

/**
 * Состояние модуля `aqsi` — только намерения фич (R01):
 * отправленные команды смены, выбор «Начала работы» и подтверждение кода кассира (RP-FB22), итоги команд окон, черновики настроек, страница
 * каталога (UC1a), отбор журнала чеков, отбор раздела «Смены» и срез доставки каталога (UC1b), очередь
 * корзины (несохранённая правка и её отправка, RP-SALE-FAST), ждущие команды оплаты и попытка оплаты с окном (UC1c, RP-PAY-ONE), продажи, чек которых печатается в фоне (быстрая оплата), черновик и ждущие команды возврата,
 * позиция журнала инцидентов и предел журнала расхождений (UC1d), поиск и
 * страница прайса кабинета (RP-FB9). Ответы
 * службы (кассы, сессии, смены, чеки, статусы) живут в кэше RTK Query.
 */
export const aqsiUiReducer = combineReducers({
  operations: operationsReducer,
  start: startReducer,
  shiftReads: shiftReadsReducer,
  cashierAccess: cashierAccessReducer,
  opening: openingReducer,
  feedback: feedbackReducer,
  catalog: catalogReducer,
  receipts: receiptsReducer,
  shifts: shiftsReducer,
  delivery: deliveryReducer,
  sale: saleReducer,
  cart: cartReducer,
  saleCommands: saleCommandsReducer,
  paymentAttempts: paymentAttemptsReducer,
  fastReceipts: fastReceiptsReducer,
  refunds: refundsReducer,
  refundCommands: refundCommandsReducer,
  incidents: incidentsReducer,
  prices: pricesReducer,
})

export type AqsiUiState = ReturnType<typeof aqsiUiReducer>
